var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMosacIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.79491 6.07587H0.280966C0.128776 6.07587 0 5.9471 0 5.79491V0.280965C0 0.128775 0.128776 0 0.280966 0H5.79491C5.9471 0 6.07588 0.128775 6.07588 0.280965V5.79491C6.08758 5.9471 5.95881 6.07587 5.79491 6.07587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7246 6.08759H12.2107C12.0585 6.08759 11.9297 5.95882 11.9297 5.80663V0.292685C11.9297 0.140496 12.0585 0.0117188 12.2107 0.0117188H17.7246C17.8768 0.0117188 18.0056 0.140496 18.0056 0.292685V5.80663C18.0056 5.95882 17.8768 6.08759 17.7246 6.08759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.79491 18.0286H0.280966C0.128776 18.0286 0 17.8998 0 17.7476V12.2337C0 12.0815 0.128776 11.9527 0.280966 11.9527H5.79491C5.9471 11.9527 6.07588 12.0815 6.07588 12.2337V17.7476C6.08758 17.8881 5.95881 18.0286 5.79491 18.0286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.7246 18.0286H12.2107C12.0585 18.0286 11.9297 17.8998 11.9297 17.7476V12.2337C11.9297 12.0815 12.0585 11.9527 12.2107 11.9527H17.7246C17.8768 11.9527 18.0056 12.0815 18.0056 12.2337V17.7476C18.0056 17.8998 17.8768 18.0286 17.7246 18.0286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.7656 12.0816H6.25167C6.09948 12.0816 5.9707 11.9528 5.9707 11.8006V6.28664C5.9707 6.13445 6.09948 6.00568 6.25167 6.00568H11.7656C11.9178 6.00568 12.0466 6.13445 12.0466 6.28664V11.8006C12.0583 11.9528 11.9295 12.0816 11.7656 12.0816Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosacIco);
export default __webpack_public_path__ + "static/media/mosac-ico.1dc6f189a812c5d4f24db942ad70fd1e.svg";
export { ForwardRef as ReactComponent };